import React from 'react';
import { getLanguageForState } from '../data/languageData';

function LanguageToggle({ stateName, currentLang, onLangChange }) {
  const langData = getLanguageForState(stateName);
  
  if (!langData) {
    return null; // No language toggle if state doesn't have language data
  }

  const otherLang = currentLang === 'en' ? langData.code : 'en';

  const handleToggle = () => {
    onLangChange(otherLang);
  };

  return (
    <div
      className="language-toggle"
      onClick={handleToggle}
      role="group"
      aria-label="Language toggle"
    >
      <button
        type="button"
        className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
        aria-pressed={currentLang === 'en'}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-btn ${currentLang === langData.code ? 'active' : ''}`}
        aria-pressed={currentLang === langData.code}
        aria-label={`Switch to ${langData.name}`}
      >
        {langData.shortName || langData.name}
      </button>
    </div>
  );
}

export default LanguageToggle;
